import { render } from "./Haccps.vue?vue&type=template&id=26084836"
import script from "./Haccps.vue?vue&type=script&lang=js"
export * from "./Haccps.vue?vue&type=script&lang=js"

import "./Haccps.vue?vue&type=style&index=0&id=26084836&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__